

















































































import FlightSegment from "@/store/entities/flight/flightSegment";
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class AddFlightSegment extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  flightSegment: FlightSegment = new FlightSegment();

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    this.flightSegment = this.$store.state.flightSegment.editFlightSegment;
    if (this.flightSegment == null) {
      this.isEdit = false;
      this.flightSegment = new FlightSegment();
    } else {
      this.isEdit = true;
    }
  }

  async saveFlightSegment() {
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "flightSegment/saveFlightSegment",
        data: this.flightSegment,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "flightSegment/saveFlightSegment",
        data: this.flightSegment,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.flightSegment.editFlightSegment = null;
  }
}
